<template>
  <div
    class="ll-avatar"
    :class="{mtLg:mtLg}"
  >
    <div
      v-if="_avatar"
      :style="{
        backgroundImage: _avatar,
        height:circleSize+'px',
        width:circleSize+'px'
      }"
      class="ll-avatar__img"
      @click="$_onClick()"
    />
    <div
      v-if="textLabel"
      class="ll-avatar__text-wrap"
    >
      <div class="ll-avatar__text-label-wrap" :class="{'no-wrap': noWrap}">
        <p :class="{bold:bold,small:small,fontSizeLg:fontSizeLg}">
          {{ textLabel }}
        </p>
        <LvText blue remark class="ml-3">{{ $t(subTextLabel) }}</LvText>
      </div>
      <p
        v-if="time"
        class="gray"
      >
        {{ `${$t(timeLabel)} ` }}<span>{{ time }}</span>
      </p>
      <p
        v-if="email"
        class="email"
      >
        {{ email }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "LlAvatar",
  props: {
    textLabel: {
      type: String,
      default: "",
    },
    subTextLabel: {
      type: String,
      default: "",
    },
    image: {
      type: String,
    },
    circleSize: {
      type: Number,
      default: 24,
    },
    bold: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    time: {
      type: String,
      default: "",
    },
    timeLabel: {
      type: String,
      default: "",
    },
    email: {
      type: String,
      default: "",
    },
    mtLg: {
      type: Boolean,
      default: false,
    },
    fontSizeLg: {
      type: Boolean,
      default: false,
    },
    noWrap: {
      type: Boolean,
      default: true,
    },
    isShowDefaultAvatar: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    _avatar() {
      return this.image
        ? 'url(' + this.image + ')'
        : this.isShowDefaultAvatar
        ? 'url(' + require('@/assets/image/avatar.svg') + ')'
        : '';
    }
  },
  methods: {
    $_onClick() {
      this.$emit("click");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/ll-avatar";
</style>